// dependencies
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import Spinner from "../../../../../../components/Spinner/ComponentLoader";
import DynamicEmployeesEdit from "./DynamicEmployees";

// api
import { useCohort } from "../../../../../../api/hooks";

// selectors
import { getURLParam } from "../../../../../../selectors/navigation";

import CohortEmployeesDirectory from "./CohortEmployeesDirectory/CohortEmployeesDirectory";
// components
import AddEmployeesDirectory from "./StaticEmployees/AddEmployeesDirectory";

const EditCohortTab = (props: { view: "employees" | "add-employees" }) => {
	const { view } = props;

	const cohortID = useSelector((state) => getURLParam(state, "cohortID"));
	const { data, isLoading } = useCohort(cohortID);

	const backUrl = useMemo(() => {
		switch (view) {
			case "employees":
				return "/administration/engagement/cohorts";
			case "add-employees":
				return `/administration/engagement/cohorts/${cohortID}`;
		}
	}, [view, cohortID]);

	if (isLoading) {
		return <Spinner />;
	}

	if (!data?.cohort) {
		return null;
	}
	const cohort = data?.cohort;

	const getAddCohortEmployeesComponent = () => {
		if (cohort.type === "static") {
			return <AddEmployeesDirectory cohortName={cohort.name} backUrl={backUrl} />;
		} else {
			return <DynamicEmployeesEdit backUrl={backUrl} cohort={cohort} />;
		}
	};

	return (
		<div>
			{view === "add-employees" ? getAddCohortEmployeesComponent() : null}
			{view === "employees" ? <CohortEmployeesDirectory cohort={cohort} backUrl={backUrl} /> : null}
		</div>
	);
};

export default EditCohortTab;
